import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(id, title) {
  return {
    title: `${title} の動画配信なら スカパー！動画ストア`,
    keywords: `${title},スカパー！動画ストア,動画配信,スカパー！`,
    description: `${title}をピックアップ！スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.palette(id)}`,
    },
  };
}

export default function PaletteMetaTags({ id, title }) {
  const props = tags(id, title);

  return <MetaTags {...props} />;
}
